import { useEffect } from "react";
import { useSearchParams, Navigate, useNavigate } from "react-router-dom";
import storageService from "@/services/middleware/storageService";
import { routesMap } from "@/components/routes/routes";
import OpticksBackground from "@/components/ui/OpticksBackground/OpticksBackground";
import OpticksSpinner from "@/components/ui/OpticksSpinner/OpticksSpinner";

const AppSumoAuth = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get("auth");
  useEffect(() => {
    storageService.setItem("token", token);
    setTimeout(() => {
      navigate(routesMap.base.path);
    }, 1000);
  }, [token]);

  if (!token) {
    return <Navigate to={routesMap.auth.login.path} replace />;
  }

  return (
    <OpticksBackground>
      <OpticksSpinner variation="blue" />
    </OpticksBackground>
  );
};

export default AppSumoAuth;
